import { globalImages } from '../../styles/GlobalStyles';
import { AuthLogo } from '../../styles/stylesStyled';
import { Layout, Main } from './authLayoutStyled';
import logo from '../../assets/images/backoffice/travelution-logo.svg';

import { useLocation } from 'react-router-dom';

const AuthLayout = ({ children, location }: any) => {
  return (
    <Layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.2
      }}
      layout>
      <Main pathname={location.pathname}>
        <AuthLogo>
          <img src={globalImages.authLayoutLogo} alt='logo' />
        </AuthLogo>
        {children}
      </Main>
    </Layout>
  );
};

export default AuthLayout;
